module.exports = __webpack_public_path__ + "assets/rosette-academy-content-bell-ring.d5d199d4.svg";